<!--
  - Copyright (c) 2018 LNBIG.com
  - All rights reserved.
  -->

<template>
  <v-app id="lnbig">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <v-list-item @click="$router.push('/')">
          <v-list-item-action>
            <v-icon>home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
<!--        <v-list-item @click="$router.push('/add-merchant')">
          <v-list-item-action>
            <v-icon>store</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Add Merchant</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->
<!--        <v-list-item @click="$router.push('/chat')">
          <v-list-item-action>
            <v-icon>chat</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Chat</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->
        <v-list-item @click="$router.push('/open-channel')">
          <v-list-item-action>
            <v-icon>input</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Open Channel</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$router.push('/our-nodes')">
          <v-list-item-action>
            <v-icon>device_hub</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Our Nodes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$router.push('/about')">
          <v-list-item-action>
            <v-icon>contact_mail</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>About</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      color="indigo"
      dark
      fixed
      app
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <v-img
          :src="require('@/assets/logo-2.svg')"
          class="my-2"
          contain
          width="140px"
          height="60px"
        />
      </v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container
        fluid
      >
        <router-view />
        <snack-bar ref="snackBar" />
      </v-container>
    </v-main>
    <v-footer
      color="#003f7f"
      app
      min-height="72"
    >
      <v-container fluid>
        <v-row>
          <v-col><v-img contain max-height="40" src="/adoptbtc/01.svg"></v-img></v-col>
          <v-col><v-img contain max-height="40" src="/adoptbtc/02.svg"></v-img></v-col>
          <v-col class="d-none d-sm-flex"><v-img contain max-height="40" src="/adoptbtc/03.svg"></v-img></v-col>
          <v-col class="d-none d-md-flex"><v-img contain max-height="40" src="/adoptbtc/04.svg"></v-img></v-col>
          <v-col class="d-none d-md-flex"><v-img contain max-height="40" src="/adoptbtc/05.svg"></v-img></v-col>
        </v-row>
      </v-container>
      <a href="https://adoptingbitcoin.org/" target="_blank" style="display: block; position: absolute; top: 0; left: 0; bottom: 0; right: 0"></a>
<!--      <span class="white&#45;&#45;text">&nbsp;&copy; LNBIG.com (2018-2025 years)</span>-->
    </v-footer>
  </v-app>
</template>

<script>
import dbg from 'debug'
const debug = dbg('lnbig:app')

import Vue from 'vue'

export default {
  data: () => ({
    drawer: null
  }),
  errorCaptured(err, vm, info) {
    if (this.$snackBar) {
      this.$snackBar.color = 'error'
      this.$snackBar.timeout = 10000
      this.$snackBar.text = err.message
      this.$snackBar.show = true
      return false
    }
  },
  mounted: function () {
    this.$nextTick(
        () => {
          Vue.prototype.$snackBar = this.$refs.snackBar
          console.log('snackBar = %o', this.$refs.snackBar)
        }
    )
  }
}
</script>

<style scoped>
div#tippin-button { display: inline-block; transform: scale(0.75) }
</style>
